/* Bob Logistics Worldwide — custom section behaviour */
(function () {
  /* Run once even if this asset is included by several sections + theme.liquid */
  if (window.__giftgoJSInit) return;
  window.__giftgoJSInit = true;

  /* ---- "Personalize your gift": live character count + uploaded filename ---- */
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-gg-perz-msg]')) {
      var box = t.closest('.gg-perz');
      var c = box && box.querySelector('[data-gg-perz-count]');
      if (c) c.textContent = t.value.length;
    }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-gg-perz-file]')) {
      var box = t.closest('.gg-perz');
      var n = box && box.querySelector('[data-gg-perz-name]');
      if (n) n.textContent = (t.files && t.files.length) ? t.files[0].name : 'Choose an image';
    }
  });

  /* ---- Personalize photo: upload to Cloudinary, save the image URL as a line-item
          property so the real photo lands on the order (no more C:\fakepath). ---- */
  (function ggCloudinaryUpload() {
    var CLOUD = 'hz3uen7f';
    var PRESET = 'bob_orders';
    var ENDPOINT = 'https://api.cloudinary.com/v1_1/' + CLOUD + '/image/upload';
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.matches || !input.matches('[data-gg-perz-file]')) return;
      var box = input.closest('.gg-perz');
      if (!box) return;
      var urlField = box.querySelector('[data-gg-perz-photo-url]');
      var nameEl = box.querySelector('[data-gg-perz-name]');
      var form = input.closest('form');
      var submitBtn = form ? form.querySelector('.product-form__submit, [type="submit"][name="add"]') : null;
      var file = input.files && input.files[0];
      if (urlField) urlField.value = '';
      if (!file) { if (nameEl) nameEl.textContent = 'Choose an image'; return; }
      if (nameEl) nameEl.textContent = 'Uploading ' + file.name + '…';
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
      var fd = new FormData();
      fd.append('file', file);
      fd.append('upload_preset', PRESET);
      fetch(ENDPOINT, { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.secure_url) {
            if (urlField) urlField.value = data.secure_url;
            if (nameEl) nameEl.textContent = '\u2713 ' + file.name;
          } else if (nameEl) { nameEl.textContent = 'Upload failed \u2014 please pick the image again'; }
        })
        .catch(function () { if (nameEl) nameEl.textContent = 'Upload failed \u2014 please pick the image again'; })
        .then(function () { if (submitBtn) submitBtn.removeAttribute('disabled'); });
    });
  })();

  /* ---- Record the viewed product (per browser) for the Recently viewed rail ---- */
  (function recordRecentlyViewed() {
    var handle = window.__giftgoProductHandle;
    if (!handle) return;
    var KEY = 'giftgo:recently-viewed';
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) list = [];
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      if (list.length > 20) list = list.slice(0, 20);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  })();

  /* ---- Periodic cart nudge: gently shake the cart icon while there are items
          in the cart that haven't been checked out yet ---- */
  (function cartNudge() {
    function itemCount() {
      var span = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      if (span) return parseInt(span.textContent, 10) || 0;
      return document.querySelector('.cart-count-bubble') ? 1 : 0;
    }
    function shake() {
      var icon = document.querySelector('#cart-icon-bubble');
      if (!icon) return;
      icon.classList.remove('giftgo-cart-shake');
      void icon.offsetWidth;
      icon.classList.add('giftgo-cart-shake');
      setTimeout(function () { icon.classList.remove('giftgo-cart-shake'); }, 700);
    }
    function tick() { if (itemCount() > 0) shake(); }
    var started = false;
    function start() {
      if (started) return;
      started = true;
      setTimeout(tick, 2500);            // first nudge shortly after load
      setInterval(tick, 6000);           // then every 6s while the cart has items
    }
    document.addEventListener('giftgo:added', start);
    if (document.readyState !== 'loading') start();
    else document.addEventListener('DOMContentLoaded', start);
  })();

  /* ---- "Added to cart" toast ---- */
  var GG_TOAST_TIMER = null;
  function showGiftgoToast() {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var toast = document.querySelector('.giftgo-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'giftgo-toast';
      toast.setAttribute('role', 'status');
      toast.innerHTML =
        '<span class="giftgo-toast__check" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.5 4.5L19 7" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>' +
        '<span class="giftgo-toast__text">Added to your cart</span>' +
        '<a class="giftgo-toast__btn" href="' + root + 'cart">View cart</a>';
      document.body.appendChild(toast);
    }
    void toast.offsetWidth;
    toast.classList.add('giftgo-toast--show');
    if (GG_TOAST_TIMER) clearTimeout(GG_TOAST_TIMER);
    GG_TOAST_TIMER = setTimeout(function () { toast.classList.remove('giftgo-toast--show'); }, 3200);
  }
  window.giftgoToast = showGiftgoToast;

  /* ---- "Buy now": add to cart then go straight to checkout ---- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-giftgo-buy]') : null;
    if (!el) return;
    e.preventDefault();
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var vid = el.getAttribute('data-variant-id');
    var fallback = el.getAttribute('href') || (root + 'cart');
    if (!vid) { window.location.href = fallback; return; }
    el.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = root + 'checkout'; })
      .catch(function () { window.location.href = fallback; });
  });

  /* ---- Hero carousel: auto-advance + dots ---- */
  class GiftgoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      if (!this.track || this.slides.length < 2) return;

      this.interval = (parseInt(this.dataset.interval, 10) || 5) * 1000;
      this.index = 0;
      this.buildDots();
      this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      this.start();
      this.addEventListener('mouseenter', this.stop.bind(this));
      this.addEventListener('mouseleave', this.start.bind(this));
    }

    buildDots() {
      this.dots = document.createElement('div');
      this.dots.className = 'giftgo-banner__dots';
      this.slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.className = 'giftgo-banner__dot';
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', () => this.goTo(i));
        this.dots.appendChild(b);
      });
      this.appendChild(this.dots);
    }

    goTo(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      // CSS `scroll-behavior: smooth` on the track handles the animation.
      this.track.scrollTo({ left: this.slides[this.index].offsetLeft });
      this.syncDots();
    }

    next() { this.goTo(this.index + 1); }

    onScroll() {
      const w = this.track.clientWidth || 1;
      const i = Math.round(this.track.scrollLeft / w);
      if (i !== this.index) { this.index = i; this.syncDots(); }
    }

    syncDots() {
      if (!this.dots) return;
      this.dots.querySelectorAll('.giftgo-banner__dot').forEach((d, i) => {
        if (i === this.index) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    start() { this.stop(); this.timer = setInterval(() => this.next(), this.interval); }
    stop() { if (this.timer) clearInterval(this.timer); }
  }
  if (!customElements.get('giftgo-carousel')) customElements.define('giftgo-carousel', GiftgoCarousel);

  /* ---- Add to cart (AJAX) with fly-to-cart, cart shake, Dawn notification ---- */
  class GiftgoAddToCart extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.variantId = this.dataset.variantId;
      if (this.button && this.variantId) {
        this.button.addEventListener('click', this.onClick.bind(this));
      }
    }

    cartIcon() { return document.querySelector('#cart-icon-bubble'); }
    cartImage() {
      // nearest product image to animate from
      var card = this.closest('.giftgo-rail__item') || this.closest('.card') || document;
      return card.querySelector('img');
    }

    flyToCart() {
      var img = this.cartImage();
      var target = this.cartIcon();
      if (!img || !target) return;
      var s = img.getBoundingClientRect();
      var t = target.getBoundingClientRect();
      var clone = img.cloneNode(true);
      clone.className = 'giftgo-fly';
      clone.style.left = s.left + 'px';
      clone.style.top = s.top + 'px';
      clone.style.width = s.width + 'px';
      clone.style.height = s.height + 'px';
      document.body.appendChild(clone);
      // force reflow then animate to cart
      clone.getBoundingClientRect();
      var dx = (t.left + t.width / 2) - (s.left + s.width / 2);
      var dy = (t.top + t.height / 2) - (s.top + s.height / 2);
      clone.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.12)';
      clone.style.opacity = '0.2';
      clone.addEventListener('transitionend', function () { clone.remove(); }, { once: true });
      setTimeout(function () { if (clone.parentNode) clone.remove(); }, 900);
    }

    shakeCart() {
      var icon = this.cartIcon();
      if (!icon) return;
      icon.classList.remove('giftgo-cart-shake');
      void icon.offsetWidth;
      icon.classList.add('giftgo-cart-shake');
      setTimeout(function () { icon.classList.remove('giftgo-cart-shake'); }, 700);
    }

    async onClick() {
      if (this.button.disabled || this.busy) return;
      this.busy = true;
      var original = this.button.textContent;
      this.button.textContent = 'Adding…';
      this.flyToCart();

      try {
        var res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: this.variantId, quantity: 1 }] })
        });
        if (!res.ok) throw new Error('add failed');
        await res.json();

        // let the fly animation land, then react
        setTimeout(() => {
          this.shakeCart();
          this.refreshCartCount();
          showGiftgoToast();
        }, 480);

        this.button.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('giftgo:added'));
      } catch (e) {
        this.button.textContent = 'Try again';
      } finally {
        setTimeout(() => { this.button.textContent = original; this.busy = false; }, 1600);
      }
    }

    async refreshCartCount() {
      try {
        var r = await fetch(window.Shopify.routes.root + 'cart.js');
        var cart = await r.json();
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var bubble = document.querySelector('.cart-count-bubble');
        if (!bubble && cart.item_count > 0) {
          var icon = document.querySelector('#cart-icon-bubble');
          if (icon) {
            var b = document.createElement('div');
            b.className = 'cart-count-bubble';
            b.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
            icon.appendChild(b);
          }
        }
      } catch (e) {}
    }
  }
  if (!customElements.get('giftgo-add-to-cart')) customElements.define('giftgo-add-to-cart', GiftgoAddToCart);

  /* ---- Product rail: slider arrows ---- */
  class GiftgoRail extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-rail-scroller]');
      this.prev = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      if (!this.scroller || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.scrollByPage(-1));
      this.next.addEventListener('click', () => this.scrollByPage(1));
      this.scroller.addEventListener('scroll', this.throttle(this.updateArrows.bind(this), 120), { passive: true });
      window.addEventListener('resize', this.throttle(this.updateArrows.bind(this), 200));
      this.updateArrows();
    }

    step() {
      var item = this.scroller.querySelector('.giftgo-rail__item');
      var w = item ? item.getBoundingClientRect().width + 16 : 220;
      var pageCount = Math.max(1, Math.floor(this.scroller.clientWidth / w));
      return w * pageCount;
    }

    scrollByPage(dir) {
      var max = this.scroller.scrollWidth - this.scroller.clientWidth;
      var target = Math.max(0, Math.min(max, this.scroller.scrollLeft + dir * this.step()));
      // Native smooth scroll (scroll-snap removed on this scroller, so it isn't cancelled).
      this.scroller.scrollTo({ left: target, behavior: 'smooth' });
    }

    updateArrows() {
      var max = this.scroller.scrollWidth - this.scroller.clientWidth - 2;
      var overflowing = max > 2;
      this.prev.hidden = !overflowing;
      this.next.hidden = !overflowing;
      if (!overflowing) return;
      this.prev.disabled = this.scroller.scrollLeft <= 2;
      this.next.disabled = this.scroller.scrollLeft >= max;
    }

    throttle(fn, ms) {
      var t = 0, self = this;
      return function () { var now = Date.now(); if (now - t >= ms) { t = now; fn.apply(self, arguments); } };
    }
  }
  if (!customElements.get('giftgo-rail')) customElements.define('giftgo-rail', GiftgoRail);
})();
